// src/pages/PendingApprovalPage.jsx

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

export default function PendingApprovalPage() {
    const { logout, userProfile } = useAuth();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="bg-white shadow-xl rounded-lg p-8 w-full max-w-md text-center border-t-4 border-yellow-500">
                <h2 className="text-2xl font-bold text-yellow-700 mb-4">Account Pending Approval</h2>
                <p className="text-gray-700">
                    Welcome, {userProfile?.displayName || userProfile?.email}!
                </p>
                <p className="text-gray-600 mt-3">
                    Your account has been created but is currently awaiting review by an administrator.
                </p>
                <p className="text-gray-600 mt-2">
                    You will be able to access your dashboard once your account is approved. Please check back later.
                </p>
                <button
                    onClick={logout}
                    className="mt-6 w-full bg-indigo-600 text-white py-2 px-4 rounded-md font-semibold hover:bg-indigo-700"
                >
                    Sign Out
                </button>
                <Link to="/" className="text-sm text-gray-500 hover:underline mt-4 inline-block">
                    Back to Home
                </Link>
            </div>
        </div>
    );
}
